import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { FiGrid, FiLogOut, FiDollarSign, FiClock, FiZap, FiUsers, FiMail  } from 'react-icons/fi';

const PlatformLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f3f4f6' }}>
      <aside style={{ width: '240px', background: '#0f172a', color: 'white', padding: '1.5rem 1rem', flexShrink: 0 }}>
        <div style={{ fontWeight: 800, fontSize: '1.1rem', marginBottom: '2rem', padding: '0 0.5rem' }}>
          Platform Admin
        </div>
        <nav>
          <Link
            to="/platform/organisations"
            style={{
              display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.7rem 0.5rem',
              borderRadius: '6px', color: 'white', textDecoration: 'none', fontSize: '0.9rem',
              background: location.pathname.startsWith('/platform/organisations') ? 'rgba(255,255,255,0.1)' : 'transparent',
            }}
          >
            <FiGrid size={16} /> Organisations
          </Link>
          <Link
            to="/platform/subscription-plans"
            style={{
              display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.7rem 0.5rem',
              borderRadius: '6px', color: 'white', textDecoration: 'none', fontSize: '0.9rem',
              background: location.pathname.startsWith('/platform/subscription-plans') ? 'rgba(255,255,255,0.1)' : 'transparent',
            }}
          >
        <FiDollarSign size={16} /> Subscription Plans
          </Link>
          <Link
            to="/platform/pending-payments"
            style={{
              display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.7rem 0.5rem',
              borderRadius: '6px', color: 'white', textDecoration: 'none', fontSize: '0.9rem',
              background: location.pathname.startsWith('/platform/pending-payments') ? 'rgba(255,255,255,0.1)' : 'transparent',
            }}
          >
            <FiClock size={16} /> Pending Payments
          </Link>
          <Link
              to="/platform/webhook-events"
              style={{
                display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.7rem 0.5rem',
                borderRadius: '6px', color: 'white', textDecoration: 'none', fontSize: '0.9rem',
                background: location.pathname.startsWith('/platform/webhook-events') ? 'rgba(255,255,255,0.1)' : 'transparent',
              }}
            >
              <FiZap size={16} /> Webhook Events
            </Link>
            <Link
                to="/platform/staff"
                style={{
                  display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.7rem 0.5rem',
                  borderRadius: '6px', color: 'white', textDecoration: 'none', fontSize: '0.9rem',
                  background: location.pathname.startsWith('/platform/staff') ? 'rgba(255,255,255,0.1)' : 'transparent',
                }}
              >
                <FiUsers size={16} /> Staff
              </Link>
              <Link
                to="/platform/email-settings"
                style={{
                  display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.7rem 0.5rem',
                  borderRadius: '6px', color: 'white', textDecoration: 'none', fontSize: '0.9rem',
                  background: location.pathname.startsWith('/platform/email-settings') ? 'rgba(255,255,255,0.1)' : 'transparent',
                }}
              >
                <FiMail size={16} /> Email Settings
            </Link>
        </nav>
        <div style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid rgba(255,255,255,0.1)', fontSize: '0.8rem', color: '#9ca3af' }}>
          <div style={{ marginBottom: '0.5rem' }}>{user?.firstName} {user?.lastName}</div>
          <button
            onClick={handleLogout}
            style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', padding: 0, fontSize: '0.8rem' }}
          >
            <FiLogOut size={14} /> Log out
          </button>
        </div>
      </aside>
      <main style={{ flex: 1, padding: '2rem' }}>
        <Outlet />
      </main>
    </div>
  );
};

export default PlatformLayout;